<template>
  <div class="table-search">
    <div
      class="table-search-item"
      v-for="(searchItem, searchIndex) in searchList"
      :key="searchIndex"
      >
      <component :is="'search-'+searchItem.type" :propKey="searchItem.prop" :items="searchItem.items" v-model="searchForm[searchItem.prop]" @search="search" :attrs="searchItem.attrs" /> 
    </div>
    <div class="table-search-item">
      <el-date-picker
        v-model="operateTime"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        :picker-options="pickerOptions"
        :clearable="false"
      />
    </div>
    <div class="table-search-item"><el-button @click="search" style="height:100%" type="primary">查询</el-button></div>
    <div class="table-search-item"><el-button @click="clear" style="height:100%">清空</el-button></div>
    <slot></slot>
  </div>
</template>

<script>
import SearchSelect from "@/components/prod/center/components/SearchSelect.vue";
import SearchInput from "@/components/prod/center/components/SearchInput.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary";
import {getDateStart, getDateEnd, pickerOptions} from "@/pages/supplier/prod/log/util"

export default {
  components: {
    SearchSelect,
    SearchInput,
  },
  data() {
    return {
      pickerOptions,
      searchForm: {
        shopId: '',
        outerId: '',
        startTime: '',
        endTime: '',
        hasRetry: 0
      },
      searchList: [
        {prop: "supply", type: 'input', attrs: {placeholder: '提报人'}},
        {prop: "status", type: 'select', attrs:{placeholder: '提报状态', clearable:true}, items: prod_center_dictionary.PUT_STATUS},
        {prop: "outerId", type: 'input', attrs: {placeholder: '款式编码'}},
      ],
      operateTime: [
        getDateStart(),
        getDateEnd(),
      ], 

    }
  },
  created() {
    const prodLogRetryFlag = sessionStorage.getItem('prodLogRetryFlag');
    if (prodLogRetryFlag) {
      const hasRetry = parseInt(prodLogRetryFlag);
      this.searchForm.hasRetry = isNaN(hasRetry) ? 0 : hasRetry;
    }
  },
  computed: {
    query() {
      let _query = {}
      this.searchForm = {
        ...this.searchForm,
        startTime: this.operateTime[0],
        endTime: this.operateTime[1]
      }
      for (const key in this.searchForm) {
        if (this.searchForm[key] !== '') {
          _query[key] = this.searchForm[key]
        }
      }
      return _query
    },
  },
  watch: {
    operateTime(newVal) {
      if(newVal == null) {
        this.operateTime = [getDateStart(),getDateEnd()]
      }
    }
  },
  methods: {
    method_getSearchForm() {
      return this.query
    },
    handleRetryFlagChanged(value) {
      sessionStorage.setItem('prodLogRetryFlag', value);
      this.search();
    },
    search() {
      this.$emit('search', this.query)
    },
    clear() {
      this.operateTime = [
        getDateStart(),
        getDateEnd(),
      ], 
      this.searchForm = {
        shopId: '',
        outerId: '',
        startTime: '',
        endTime: ''
      }
      this.search();
    },
  }
}
</script>

<style lang="scss" scoped>
.table-search {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;

  &-item {
    margin-right: 8px;
    margin-bottom: 8px;
    line-height: 28px;
  }

}
</style>
